<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="(weekday, code) of weekdays"
      :value="code"
      :key="code">
        {{ weekday }}
    </option>
  </select>
</template>
<script lang="ts">
import { weekdayKey, Weekdays } from '@/store/common.types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SelectWeekdayInput extends Vue {
  @Prop() value!: weekdayKey

  private weekdays = Weekdays

  private get selected(): weekdayKey {
    return this.value
  }

  private set selected(weekday: weekdayKey) {
    this.$emit('input', weekday)
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
